
import { HttpHeaders } from '@angular/common/http';

/**
 * Services d'appel REST au back
 */
export abstract class RestService {

  /**
   * Libellé content type
   */
  private static readonly CONTENT_TYPE = 'Content-Type';

  /**
   * Retourne, en fonction du paramètre type le header à utiliser pour la requête http.
   * Le cookie d'authentification (ACCESS_TOKEN) est ajouté automatiquement à toutes les
   * requêtes vers le backend par le CredentialsInterceptor, il n'y a rien à faire ici.
   *
   * @param {any} type
   * @returns {HttpHeaders}
   */
   protected createAuthorizationHeader(type = null): HttpHeaders {
    switch (type) {
      case 'json':
        return new HttpHeaders({ [RestService.CONTENT_TYPE]: 'application/json' });
      case 'form-data':
        return new HttpHeaders({ [RestService.CONTENT_TYPE]: 'multipart/form-data' });
      default:
        return new HttpHeaders({ [RestService.CONTENT_TYPE]: 'application/x-www-form-urlencoded' });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/rest.service.ts